var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, property, LitElement } from 'lit-element';
import { register } from '@polleverywhere/hmr-custom-element';
import { classMap } from 'lit-html/directives/class-map.js';
import '../style/list-paginator.scss';
/**
 * Pagination buttons
 *
 * `<list-paginator current=3 total=5 />`
 *
 * @element list-paginator
 *
 * @attr {integer} current - Which page you're on
 * @attr {integer} total - The total number of pages
 * @attr {integer} [show=5] - Max pages to show
 *
 * @fires {string} click:page - Fires when page to switch to is clicked.
 */
export class ListPaginator extends LitElement {
    constructor() {
        super(...arguments);
        this.current = 0;
        this.total = 0;
        this.show = 5;
    }
    render() {
        return html `
      <button class="list-paginator__nav" @click=${this.triggerPrev} ?disabled=${this.current <= 1}>Prev</button>
      <div class="list-paginator__pages">
        ${this.renderPages()}
      </div>
      <button class="list-paginator__nav" @click=${this.triggerNext} ?disabled=${this.total === 0 || this.current === this.total}>Next</button>
    `;
    }
    createRenderRoot() {
        /**
         * Render template without shadow DOM. Note that shadow DOM features like
         * encapsulated CSS and slots are unavailable.
         */
        return this;
    }
    renderPages() {
        if (this.total === 0) {
            return html ``;
        }
        let i = 1;
        let limit = this.total;
        if (this.show > 0) {
            const sideCount = Math.floor(this.show / 2);
            const start = Math.max(1, this.current - sideCount);
            const end = Math.min(this.total, this.current + sideCount);
            i = Math.max(1, start - Math.max(0, Math.abs((end - this.current) - sideCount)));
            limit = Math.min(this.total, end + Math.abs((this.current - start) - sideCount));
        }
        const pages = [];
        for (i; i <= limit; i++) {
            pages.push(html `<button
        class=${classMap({ 'list-paginator__page': true })}
        data-page=${i}
        @click=${this.pageClick}
        aria-pressed=${this.current === i}
        >${i}</button>`);
        }
        return pages;
    }
    pageClick(e) {
        if (e.currentTarget instanceof Element) {
            const page = e.currentTarget.getAttribute('data-page') || '';
            this.triggerPageChange(parseInt(page));
        }
    }
    triggerNext() {
        this.triggerPageChange(this.current + 1);
    }
    triggerPrev() {
        this.triggerPageChange(this.current - 1);
    }
    triggerPageChange(page) {
        this.dispatchEvent(new CustomEvent('change:page', {
            bubbles: true,
            detail: { page }
        }));
    }
}
ListPaginator.tagName = 'list-paginator';
__decorate([
    property({ type: Number })
], ListPaginator.prototype, "current", void 0);
__decorate([
    property({ type: Number })
], ListPaginator.prototype, "total", void 0);
__decorate([
    property({ type: Number })
], ListPaginator.prototype, "show", void 0);
register(module, ListPaginator.tagName, ListPaginator);
//# sourceMappingURL=list-paginator.js.map